(function () {
  'use strict';

  var STORAGE_KEY = 'hillmalaya:recently-viewed';
  var MAX_HISTORY = 20;
  var memoryStore = null; // fallback when localStorage is unavailable
  var LAST_ADDED_KEY = 'hillmalaya:last-added';
  var lastAddedMemory = null; // fallback when localStorage is unavailable

  function readRaw() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return Array.isArray(memoryStore) ? memoryStore : [];
    }
  }

  function writeRaw(list) {
    memoryStore = list;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) { /* unavailable/full — keep memoryStore only */ }
  }

  function sanitize(list) {
    var seen = {};
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var e = list[i];
      if (!e || typeof e.handle !== 'string') continue;
      var id = Number(e.id);
      if (!id || seen[id]) continue;
      seen[id] = true;
      out.push({ handle: e.handle, id: id, ts: Number(e.ts) || 0 });
      if (out.length >= MAX_HISTORY) break;
    }
    return out;
  }

  function getAll() { return sanitize(readRaw()); }

  function record(entry) {
    if (!entry || typeof entry.handle !== 'string') return;
    var id = Number(entry.id);
    if (!id) return;
    var list = getAll().filter(function (e) { return e.id !== id; });
    list.unshift({ handle: entry.handle, id: id, ts: Date.now() });
    writeRaw(sanitize(list));
  }

  function getHandles() { return getAll().map(function (e) { return e.handle; }); }
  function getIds() { return getAll().map(function (e) { return e.id; }); }

  function recordAdded(entry) {
    if (!entry || typeof entry.handle !== 'string') return;
    var id = Number(entry.id);
    if (!id) return;
    var rec = { handle: entry.handle, id: id, ts: Date.now() };
    lastAddedMemory = rec;
    try {
      window.localStorage.setItem(LAST_ADDED_KEY, JSON.stringify(rec));
    } catch (e) { /* unavailable/full — keep lastAddedMemory only */ }
  }

  function getLastAdded() {
    try {
      var raw = window.localStorage.getItem(LAST_ADDED_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed.handle === 'string' && Number(parsed.id)) return parsed;
      }
    } catch (e) { /* fall through to memory */ }
    return lastAddedMemory;
  }

  function resolveSeed() {
    var added = getLastAdded();
    if (added && added.id) return added.id;
    var all = getAll();
    if (all.length && all[0] && all[0].id) return all[0].id;
    return null;
  }

  window.HillmalayaRecentlyViewed = {
    record: record,
    recordAdded: recordAdded,
    getLastAdded: getLastAdded,
    getAll: getAll,
    getHandles: getHandles,
    getIds: getIds,
    resolveSeed: resolveSeed
  };

  function captureCurrent() {
    var el = document.getElementById('recently-viewed-current');
    if (!el) return;
    try {
      var data = JSON.parse(el.textContent);
      if (data && data.handle && data.id) record({ handle: data.handle, id: data.id });
    } catch (e) { /* malformed island — ignore */ }
  }

  function parseExcludeIds(str) {
    var map = {};
    if (!str) return map;
    str.split(/\s+/).forEach(function (s) {
      var n = Number(s);
      if (n) map[n] = true;
    });
    return map;
  }

  function fetchCard(handle) {
    // Prefix with Shopify's localized root (e.g. "/zh-hant/") so the card renders in the
    // active language/market. A bare "/products/..." drops the locale → English cards.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var url = root + 'products/' + encodeURIComponent(handle) + '?view=card';
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .catch(function () { return null; });
  }

  function injectResults(root, listEl, layout, htmlList) {
    var parser = new DOMParser();
    var injected = 0;
    htmlList.forEach(function (html) {
      if (!html) return;
      var doc = parser.parseFromString(html, 'text/html');
      var card = doc.querySelector('[data-recently-viewed-card]');
      if (!card) return;
      var cell = card.firstElementChild;
      while (cell) {
        var next = cell.nextElementSibling;
        if (layout === 'slider') cell.classList.add('gallery-cell');
        listEl.appendChild(cell);
        cell = next;
      }
      injected++;
    });
    return injected;
  }

  function revealSection(root) {
    root.removeAttribute('hidden');
    root.classList.add('rv--ready');
    // Reveal the whole Shopify section wrapper (its padding + any divider stay hidden until now).
    var wrapper = root.closest ? root.closest('.shopify-section') : null;
    if (wrapper) wrapper.classList.add('rv--ready');
    try { if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) Shopify.PaymentButton.init(); } catch (e) {}
    try { if (window.PXUTheme && window.PXUTheme.currencyConverter) window.PXUTheme.currencyConverter.convertCurrencies(); } catch (e) {}
  }

  function initSlider(listEl) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.flickity) return; // no Flickity -> leave as static row
    var perSlide = parseInt(listEl.getAttribute('data-products-per-slide'), 10) || 1;
    var limit = parseInt(listEl.getAttribute('data-products-limit'), 10) || perSlide;
    var available = parseInt(listEl.getAttribute('data-products-available'), 10) || 0;
    var $slider = $(listEl);
    // Too few cells to scroll: center them, mirror relatedProducts()'s small-count branch
    if (available < perSlide || limit < perSlide) {
      $slider.addClass('container is-justify-center');
      $slider.find('.gallery-cell').addClass('column');
      return;
    }
    var wrapAround = available > perSlide && limit > perSlide;
    $slider.flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: limit > perSlide,
      initialIndex: 0,
      arrowShape: window.arrowShape
    });
    $slider.on('settle.flickity', function () { $slider.flickity('resize'); });
    $(window).on('load', function () { $slider.flickity('resize'); });
  }

  function hydrateSection(root) {
    if (!root || root.getAttribute('data-rv-hydrated') === 'true') return;
    root.setAttribute('data-rv-hydrated', 'true');

    var layout = root.getAttribute('data-layout') || 'grid';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 6;
    var excludeIds = parseExcludeIds(root.getAttribute('data-exclude-ids'));
    var listEl = root.querySelector('[data-recently-viewed-list]');
    if (!listEl) return;

    var entries = getAll().filter(function (e) { return !excludeIds[e.id]; }).slice(0, limit);
    if (entries.length === 0) return;

    Promise.all(entries.map(function (e) { return fetchCard(e.handle); })).then(function (htmlList) {
      var injected = injectResults(root, listEl, layout, htmlList);
      if (injected === 0) return;
      if (layout === 'slider') {
        listEl.setAttribute('data-products-available', injected);
        initSlider(listEl);
      }
      revealSection(root);
    });
  }

  function hydrateAll() {
    var sections = document.querySelectorAll('[data-recently-viewed]');
    for (var i = 0; i < sections.length; i++) hydrateSection(sections[i]);
  }

  function init() {
    captureCurrent();
    hydrateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var sectionEl = evt.target && evt.target.querySelector ? evt.target.querySelector('[data-recently-viewed]') : null;
    if (!sectionEl) return;
    var listEl = sectionEl.querySelector('[data-recently-viewed-list]');
    if (listEl) {
      if (listEl.classList.contains('flickity-enabled') && window.jQuery) {
        try { window.jQuery(listEl).flickity('destroy'); } catch (e) {}
      }
      while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
    }
    sectionEl.removeAttribute('data-rv-hydrated');
    hydrateSection(sectionEl);
  });
})();
